import { useContext } from 'react';
import { SignupContext } from '../context/SignupContext/SignupContext';

export const useSignup = () => {
  const contextValue = useContext(SignupContext);

  return contextValue;
};
